import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { ReportResponse } from "../../responses/orchestrator-patient/report.response";
import { FrontDeskPatientReportRequest } from "../../requests/orchestrator-patient/front-desk-patient-report.request";
import { FrontdeskReportResponse } from "../../responses/orchestrator-patient/front-desk-report.response";

@Injectable({
    providedIn: 'root'
  })
  export class ReportService extends CommonService{
  
    constructor(private router: Router, private httpClient: HttpClient) {
      super();
    }

    public getReportPDF(request: FrontDeskPatientReportRequest): Observable<FrontdeskReportResponse>{
        let uri = `FrontDeskPatientReport`;
    
        return this.httpClient.post<FrontdeskReportResponse>(environment.urlApiOrchestratorPatient + uri, request, this.addHeaderToken())
        .pipe(
          catchError(this.handleError)
        )
    }
}